import AuthService from "../../auth/services/AuthService"

// Models
import RecordsServiceType from "./RecordsServiceType"
import AuthServiceType from "../../auth/services/AuthServiceType"
import HttpServiceType from "../../http/services/HttpService/HttpServiceType"

// Constants
import {RecordsEndpoint} from "../constants"
import {RequestMethod} from "../../../constants"

const RecordsService: RecordsServiceType & AuthServiceType & HttpServiceType = Object.create(AuthService);

RecordsService.fetchNext = function fetchNext() {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.NEXT}`, {
        headers: this.getAuthHeader(),
    })
};

RecordsService.fetchNextById = function fetchNextById(id: string) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.NEXT_BY_ID.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
    })
};

RecordsService.fetchNextInprogressById = function fetchNextInprogressById(id: string) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.INPORGRESS_BY_ID.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
    })
};

/**
 * @param id
 */
RecordsService.fetchById = function fetchById(id) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.BY_ID.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
    })
};

/**
 * @param id
 */
RecordsService.fetchRecordSignal = function fetchRecordSignal(id) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.SIGNAL.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
    })
};

/**
 * @param id
 */
RecordsService.approveRecord = function approveRecord(id) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.APPROVE.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
        method: RequestMethod.POST,
    })
};

/**
 * @param conclusion
 * @param id
 */
RecordsService.updateConclusion = function updateConclusion(conclusion, id) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.UPDATE_CONCLUSION.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
        method: RequestMethod.POST,
        body: JSON.stringify({conclusion}),
    })
};

RecordsService.updateParameters = function updateConclusion(params, id) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.UPDATE_PARAMETERS.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
        method: RequestMethod.PATCH,
        body: JSON.stringify(params),
    })
};

RecordsService.updateInterpretation = function updateInterpretation(interpretation, id) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.UPDATE_INTERPRETATION.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
        method: RequestMethod.POST,
        body: JSON.stringify({interpretation}),
    })
};

RecordsService.fetchPDF = function fetchPDF(id) {
    return this.request(`${this.getApiUrl()}${RecordsEndpoint.PDF.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
        responseType: 'arraybuffer',
    })
};

export default RecordsService
